import type { ApiError } from "@/types/auth.type";

/** HttpCoreService rejects with ApiError (plain object), not Error. */
export function isApiError(err: unknown): err is ApiError {
  return (
    typeof err === "object" &&
    err !== null &&
    "status" in err &&
    typeof (err as ApiError).status === "number"
  );
}

/**
 * Get user-facing message from a caught error.
 * HttpCoreService rejects with ApiError (plain object), not Error.
 */
export function getErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === "object") {
    const axiosMsg = (err as { response?: { data?: { message?: string } } })
      .response?.data?.message;
    if (typeof axiosMsg === "string" && axiosMsg.trim()) {
      return axiosMsg;
    }
  }
  if (
    isApiError(err) &&
    typeof err.message === "string" &&
    err.message.trim()
  ) {
    return err.message;
  }
  if (err instanceof Error && err.message) {
    return err.message;
  }
  if (err && typeof err === "object" && "message" in err) {
    const msg = (err as { message?: unknown }).message;
    if (typeof msg === "string" && msg.trim()) {
      return msg;
    }
  }
  return fallback;
}
